var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMilkBottle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 471,
    viewBox: "0 0 462 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_437_652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.567 395.197C357.567 395.197 347.953 396.243 342.465 393.71C340.47 392.789 339.932 390.832 341.448 389.105C342.628 387.771 345.123 386.428 350.352 386.054C352.952 385.871 355.571 385.526 358.162 384.931C371.45 381.89 406.565 370.683 432.25 333.87C432.25 333.87 433.151 332.469 434.859 331.011C439.503 327.039 447.745 327.988 448.09 332.469C448.301 335.28 446.823 339.578 440.539 345.882C440.539 345.882 400.55 390.803 357.567 395.188",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.698 367.133C266.698 367.133 320.072 360.245 348.644 352.368C377.216 344.5 610.446 72.4989 610.446 72.4989C610.446 72.4989 600.065 17.0817 566.706 -15.6064C528.894 -52.6504 446.382 -111.502 416.956 -123.649C391.138 -134.318 322.931 -139 322.931 -139C322.931 -139 80.989 128.751 73.6493 145.244C66.3096 161.727 72.0662 217.144 72.0662 217.144C72.0662 217.144 2.44922 295.53 15.2961 282.252C28.1334 268.973 78.2162 293.381 129.143 342.629C180.07 391.877 198.079 444.455 185.242 457.733L266.708 367.143L266.698 367.133Z",
    stroke: "white",
    strokeWidth: 9.83142,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.453 456.601C172.971 469.4 124.365 439.791 75.9232 393.335C27.4907 346.879 2.08475 296.374 14.5671 283.566C27.0494 270.767 74.3402 298.888 122.782 345.344C171.224 391.8 197.945 443.792 185.462 456.591L185.453 456.601Z",
    stroke: "white",
    strokeWidth: 9.83142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.901 333.553C207.692 280.995 158.195 240.411 99.6211 218.449C96.359 217.221 94.9486 219.399 95.9848 222.296C97.2896 225.933 101.329 229.108 104.869 230.432C157.024 249.976 200.449 285.658 229.117 332.44C230.863 335.29 234.864 339.358 238.634 339.339C242.53 339.319 241.119 335.549 239.891 333.553",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7142 254.16L27.2223 242.55L55.7848 86.3056L268.282 231.843L218.352 441.241L210.897 434.515",
    stroke: "white",
    strokeWidth: 9.83142,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.678 456.601C175.196 469.4 126.591 439.791 78.1488 393.335C29.7163 346.87 4.31034 296.365 16.7926 283.566C29.275 270.767 76.5657 298.888 125.008 345.344C173.45 391.8 200.17 443.792 187.688 456.591",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.309 92.8873C102.27 90.0569 96.7049 91.0356 93.8746 95.0748L77.9479 117.833C75.1175 121.872 76.0961 127.446 80.1354 130.267L202.598 216.022C206.638 218.852 212.202 217.864 215.033 213.825L230.959 191.076C233.79 187.037 232.811 181.463 228.772 178.642L106.309 92.8873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_437_652",
    x: 0,
    y: -150.416,
    width: 621.862,
    height: 621.42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.427451 0 0 0 0 0.623529 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_437_652"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_437_652",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilkBottle);
export default __webpack_public_path__ + "static/media/milk_bottle.482a70f44446d369ab4a248fc8df5694.svg";
export { ForwardRef as ReactComponent };